import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function HopeSection() {
  return <section className="py-12 bg-gradient-to-br from-yellow/10 via-yellow/8 to-yellow/15 relative overflow-hidden" data-id="element-115">
      <div className="absolute top-10 right-10 w-64 h-64 bg-yellow/20 rounded-full blur-3xl" data-id="element-116" />
      <div className="absolute bottom-10 left-10 w-64 h-64 bg-yellow/25 rounded-full blur-3xl" data-id="element-117" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-118">
        <div className="max-w-3xl mx-auto text-center" data-id="element-119">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-120">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-yellow/20 text-yellow-700 font-bold text-sm mb-8" data-id="element-121">
              <Sparkles size={16} data-id="element-122" />
              Imagina esto por un momento
            </div>

            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-123">
              Ahora imagina esto por un momento
            </h2>

            <div className="space-y-6 text-xl text-slate-700 mb-12" data-id="element-124">
              <p data-id="element-125">Imagínate cobrar la quincena y no sentir ansiedad.</p>
              <p data-id="element-126">Saber exactamente cuánto puedes gastar.</p>
              <p data-id="element-127">Tomar decisiones sin culpa.</p>
              <p data-id="element-128">Ver tu dinero con claridad.</p>
            </div>

            <div className="bg-white p-8 rounded-2xl shadow-xl border-l-4 border-[#1a3d3d]" data-id="element-129">
              <p className="text-lg text-slate-600 mb-4" data-id="element-130">
                No sentirte castigada. No vivir restringida. Sentir control.
              </p>
              <p className="text-xl font-bold text-[#f4c430]" data-id="element-131">
                No porque ganes más. Sino porque por fin tienes un sistema que
                sí funciona para ti.
              </p>
            </div>

            <p className="text-2xl font-bold text-slate-900 mt-12" data-id="element-132">
              Eso es lo que cambia todo.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}